<template>
    <h1>{{ $route.query.message }}</h1>
</template>

<script>
export default {
    data() {
        return {
            message: this.$route.query.message
                ? this.$route.query.message
                : "Not Found"
        };
    }
};
</script>

<style></style>
